/*
 * @Author: shannyHuang
 * @Date: 2022-08-04 11:13:21
 * @LastEditors:
 * @LastEditTime: 2022-08-04 14:37:03
 * @FilePath: /wemeet-web-activity/src/components/HeadUploadMobile/index.tsx
 */
/* eslint-disable arrow-body-style */
import React, { useCallback, useRef } from 'react';
import type { FC } from 'react';
import { message } from '@tencent/tea-component';
import Img from '@tencent/tpm-meeting-active/lib/Img/index';
import '@tencent/tpm-meeting-active/lib/Img/style/index';
import { useUpload, UploadResult } from '../HeadUpload/upload-hook';
export type { UploadResult } from '../HeadUpload/upload-hook';

const HeaderUploadMobile: FC<{
  defaultUrl: string;
  onUploadComplete: (data: UploadResult) => void;
  txt: string;
  onUploadClick?: () => void;
}> = ({ defaultUrl, onUploadComplete, onUploadClick = () => {} }) => {
  const { avatarImg, beforeUpload } = useUpload(defaultUrl, onUploadComplete);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const onSelect: React.ChangeEventHandler<HTMLInputElement> = useCallback((e) => {
    const { files } = e.currentTarget;
    if (!files?.length || !files.item(0)) return;
    if (files.item(0)!.size / 1024 / 1024 > 5) {
      message.error({ content: '请选择不大于 5M 的图片' });
      return false;
    }
    beforeUpload(files.item(0)!).then((data) => {
      console.log(data);
    });
  }, []);

  const triggerSelect = useCallback(() => {
    inputRef.current?.click();
  }, [inputRef.current]);

  return (
    <>
      <Img type="avatar" modifyAvatar={true} src={avatarImg} onClick={triggerSelect} />
      <input
        type="file"
        onClick={onUploadClick}
        onChange={onSelect}
        accept="image/png, image/jpeg"
        ref={inputRef}
        style={{
          opacity: 0,
          height: 0,
        }}
      />
    </>
  );
};

export default HeaderUploadMobile;
